import React, { Component } from 'react';
import ScreenLoader from '../ScreenLoader/ScreenLoader';
import Message from '../Message/Message';
import Api from '../../helpers/Api';
import './Status.css';

export default class Status extends Component {
  static isPrivate = true;

  static formatCurrency(number) {
    return number.toLocaleString('en-GB', { maximumFractionDigits: 2 });
  }

  constructor(props) {
    super(props);
    this.timeouts = [];
    this.cancellers = [];
    this.state = {
      isLoading: false,
      currentBalance: null,
      openStakes: null,
      todayPL: null,
      yesterdayPL: null,
    };
    this.api = new Api('status');
  }

  componentDidMount() {
    this.api.start({
      onBefore: this.requestWillStart.bind(this),
      onSuccess: this.requestDidComplete.bind(this),
      onError: this.requestDidCatch.bind(this),
    });
  }

  componentWillUnmount() {
    this.api.stop();
  }

  requestWillStart() {
    this.setState({ isLoading: true });
    this.props.updateRefresh(true, false);
  }

  requestDidComplete(data) {
    this.setState({
      currentBalance: Number(data.filter(x => x["key"] === "current_balance")[0].value),
      openStakes: Number(data.filter(x => x["key"] === "open_stakes")[0].value),
      todayPL: Number(data.filter(x => x["key"] === "today_pl")[0].value),
      yesterdayPL: Number(data.filter(x => x["key"] === "yesterday_pl")[0].value),
      isLoading: false,
    });
    this.props.updateRefresh(false, false);
  }
  

  requestDidCatch(error) {
    this.setState({ isLoading: false });
    this.props.updateRefresh(false, error instanceof Api.CancelError ? false : error);
  }

  hasValues() {
    return this.state.currentBalance !== null &&
      this.state.openStakes !== null &&
      this.state.todayPL !== null &&
      this.state.yesterdayPL !== null;
  }

  render() {
    if (!this.hasValues()) {
      return this.state.isLoading
        ? <ScreenLoader />
        : <Message type="warning" text="No data" />;
    }

    return (
      <div className="Status container">
        <div className="list-group Status__inner">
          <div className="list-group-item">
            <h4 className="list-group-item-heading">{Status.formatCurrency(this.state.currentBalance)} EUR</h4>
            <p className="list-group-item-text">Balance</p>
          </div>
          <div className="list-group-item">
            <h4 className="list-group-item-heading">{Status.formatCurrency(this.state.openStakes)} EUR</h4>
            <p className="list-group-item-text">Open stake</p>
          </div>
          <div className="list-group-item">
            <h4 className="list-group-item-heading">{Status.formatCurrency(this.state.todayPL)} EUR</h4>
            <p className="list-group-item-text">Today P&L</p>
          </div>
          <div className="list-group-item">
            <h4 className="list-group-item-heading">{Status.formatCurrency(this.state.yesterdayPL)} EUR</h4>
            <p className="list-group-item-text">Yesterday P&L</p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Status/Status.js